import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Star, StarBorder, StarHalf } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

type ContainerProps = {
  mobile?: boolean;
  editable: boolean;
  margin?: any;
};
const Container = styled(Box, {
  shouldForwardProp: (prop) => prop !== "mobile" && prop !== "editable" && prop !== "margin",
})<ContainerProps>(({ theme, mobile, editable, margin }) => ({
  display: "flex",
  alignItems: "center",
  margin: margin || (mobile ? "0 0" : "10px 0"),
  fontStyle: "italic",
  fontSize: "11px",
  color: theme.palette.grey["800"],
  cursor: editable ? "pointer" : "default",
  "& svg": {
    width: "14px",
    color: "#FFD157",
  },
  "& span": {
    marginLeft: "10px",
  },
}));

export const Rating = ({
  score,
  numberOfReviews,
  onSubmit,
  display,
  mobile,
}: {
  score: number;
  numberOfReviews: number;
  onSubmit?: () => void;
  display?: boolean | string;
  mobile?: boolean;
}): React.ReactElement => {
  const handleClick = () => {
    if (typeof onSubmit === "function") {
      onSubmit();
    }
  };
  const { t } = useTranslation();

  return (
    <Container
      display="flex"
      alignItems="center"
      mobile={mobile}
      editable={typeof onSubmit === "function"}
      aria-label={t("aria_label_average_rating_for_course") + " " + score}
    >
      {/* Ugly, but functional. */}
      <Box
        onClick={handleClick}
        tabIndex={0}
        role="link"
        aria-label={t("aria_label_average_rating_for_course") + " " + score}
      >
        {score < 1 ? score === 0.5 ? <StarHalf /> : <StarBorder /> : <Star />}
        {score < 2 ? score === 1.5 ? <StarHalf /> : <StarBorder /> : <Star />}
        {score < 3 ? score === 2.5 ? <StarHalf /> : <StarBorder /> : <Star />}
        {score < 4 ? score === 3.5 ? <StarHalf /> : <StarBorder /> : <Star />}
        {score < 5 ? score === 4.5 ? <StarHalf /> : <StarBorder /> : <Star />}
      </Box>
      <Typography
        component="span"
        style={{ fontStyle: "italic", fontSize: "11px", marginLeft: "10px" }}
        aria-label={t("aria_label_average_rating_for_course") + " " + score}
      >
        {display ? `(${numberOfReviews})` : t("number_of_reviews", { count: numberOfReviews })}
      </Typography>
    </Container>
  );
};
